const SESSION_KEY_PREFIX = "save_goal_planned_activate:";

/** PLANNED 已 confirm、待二次 Paywall activate 的 goalId（按 toolCallId 存 session，防 chat 刷新丢 state） */
export const getSaveGoalPlannedActivateGoalId = (
  toolCallId?: string,
): string | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const id = toolCallId?.trim();
  if (!id) {
    return undefined;
  }

  const value = sessionStorage.getItem(`${SESSION_KEY_PREFIX}${id}`)?.trim();
  return value || undefined;
};

export const persistSaveGoalPlannedActivateGoalId = (
  toolCallId: string,
  goalId: string,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  const callId = toolCallId.trim();
  const trimmedGoalId = goalId.trim();
  if (!callId || !trimmedGoalId) {
    return;
  }

  sessionStorage.setItem(`${SESSION_KEY_PREFIX}${callId}`, trimmedGoalId);
};

export const clearSaveGoalPlannedActivateGoalId = (
  toolCallId?: string,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  const id = toolCallId?.trim();
  if (!id) {
    return;
  }

  sessionStorage.removeItem(`${SESSION_KEY_PREFIX}${id}`);
};
